export const _data = state => state?.filters?.data
export const _loading = state => state?.filters?.loading
export const _selected = state => state?.filters?.selected
export const _data_categories = state => state?.filters?.data?.categories
export const _data_classes = state => state?.filters?.data?.classes
export const _clubs = state => state?.filters?.clubs
export const _search = state => state?.filters?.search
